<template>
  <div class="footers">
    <div class="PC" v-if="facilityFooter">
      <el-row>
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
          <div class="footer_logo_box">
            <img src="@/assets/home/logo.png" alt="logo" />
            <div class="name">
              岩石科技是一家专业从事地理信息的高新技术企业，获得由市科委、市财政局、市国税局、市地税局颁发的高新技术企业证书，岩石科技拥有乙级测绘资质证书和信息系统集成及服务三级资质证书。
            </div>
          </div>
          <div class="footer_info_box">
            <div class="footer_nav">
              <span
                v-for="(item, index) in navigation"
                :key="index"
                @click="handleNavigation(item, index)"
              >
                {{ item.title }}
              </span>
            </div>
            <div class="footer_info">
              <p>
                <i class="iconfont iconquanqiu" style="font-size: 0.165rem"></i>
                <span>公司：武汉岩石科技有限公司</span>
              </p>
              <p>
                <i class="el-icon-phone"></i>
                <span>电话：400-000-7168</span>
              </p>
              <p>
                <i class="el-icon-message"></i>
                <span>邮箱：info@qimysafe.com</span>
              </p>
              <p>
                <i class="el-icon-location-outline"></i>
                <span>地址：武汉市洪山区文化大道融创智谷A7栋8号楼</span>
              </p>
            </div>
            <p>@Copyright 武汉岩石科技有限公司版权所有</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="mobile" v-else>
      <div class="footer_box">
        <img src="@/assets/home/logo.png" alt="logo" />
        <div class="footer_info">
          <p>
            <i class="el-icon-office-building"></i>
            <span>公司：武汉岩石科技有限公司</span>
          </p>
          <p>
            <i class="el-icon-phone"></i>
            <span>电话：400-000-7168</span>
          </p>
          <p>
            <i class="el-icon-message"></i>
            <span>邮箱：info@qimysafe.com</span>
          </p>
          <p>
            <i class="el-icon-location-outline"></i>
            <span
              >地址：武汉市洪山区马湖村武汉创意天地三、四期第6号楼4层1层</span
            >
          </p>
        </div>
        <p>@Copyright 武汉岩石科技有限公司版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
import homeData from '@/static/data.json'

export default {
  name: 'footers',
  props: ['facilityFooter'],

  created() {
    this.navigation = homeData.data.navigation.slice(
      0,
      homeData.data.navigation.length - 1
    )
  },

  methods: {
    // PC 导航切换
    handleNavigation(item, i) {
      this.$router.push(this.navigation[i].path)
      let navigation = {
        title: item.title,
        index: i
      }
      this.resetSetItem('navigation', JSON.stringify(navigation))
    }
  }
}
</script>

<style lang="scss" scoped>
.footers {
  .PC {
    width: 100%;
    height: 54.2156vh;
    background: url(../assets/home/footer_bg.png) no-repeat;
    background-size: 100% 100%;
    .el-col {
      display: flex;
      justify-content: space-between;
      color: #eee;
      font-size: 0.186rem;
      .footer_logo_box {
        background-color: #1f60a3;
        width: 25.625vw;
        height: 54.2156vh;
        img {
          margin: 10.5656vh auto 5.8698vh auto;
          display: block;
          width: 12.2396vw;
          height: 7.0438vh;
        }
        .name {
          width: 19.0625vw;
          color: #eee;
          font-size: 0.186rem;
          line-height: 4.1622vh;
          margin: 0 auto;
        }
      }
      .footer_info_box {
        margin-left: 8.75vw;
        .footer_nav {
          margin: 10.4589vh 0;
          position: relative;
          span {
            display: inline-block;
            width: 6.25vw;
            text-align: center;
            cursor: pointer;
          }
          span::after {
            content: '';
            width: 7.8125vw;
            height: 1.8143vh;
            display: block;
            position: absolute;
            top: 0.7471vh;
            border-left: 0.02rem solid #eee;
          }
          span:last-child::after {
            content: '';
            width: 6.25vw;
            height: 1.8143vh;
            display: block;
            position: absolute;
            top: 0.7471vh;
            border-right: 0.02rem #eee solid;
          }
        }
        .footer_info {
          margin-bottom: 0.5rem;
          p {
            margin-bottom: 0.2rem;
            i {
              color: #afafaf;
            }
            span {
              display: inline-block;
              margin-left: 0.4167vw;
            }
          }
        }
        p {
          color: #bfbfbf;
        }
      }
    }
  }
  .mobile {
    .footer_box {
      width: 100%;
      height: 2.55rem;
      background: url(../assets/home/footer_bg.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 0.2rem;
      padding-top: 0.2rem;
      text-align: center;
      color: #fff;
      font-size: 0.1rem;
      box-sizing: border-box;
      img {
        width: 0.9rem;
        height: 0.28rem;
      }
      .footer_info {
        width: 2.8rem;
        text-align: left;
        margin: 0.2rem auto 0.2rem auto;
        p {
          margin-bottom: 0.05rem;
          line-height: 0.2rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footers.vue